"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAssetForVariant = exports.getVariantDataForCart = exports.getProductOverrides = exports.getDefaultAttributes = exports.findVariantsWithAttributeValue = exports.findMatchingVariants = exports.findMatchingVariant = exports.findClosestVariant = exports.transformCatalogProducts = exports.getStateFromVariant = exports.getInitialState = exports.mergeProductAttributes = void 0;
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const pick_1 = __importDefault(require("lodash/pick"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
/**
 * Returns an object with the product defaults for each option (size, height, color)
 * @param {Object} product
 * @returns {import('./selection.types.js').AttributeValue}
 */
const getDefaultAttributes = (product = {}) => {
    const defaultAttributes = {};
    Object.entries(product.options).forEach(([attributeCode, attributeOption]) => {
        defaultAttributes[attributeCode] = attributeOption.default;
    });
    return defaultAttributes;
};
exports.getDefaultAttributes = getDefaultAttributes;
/**
 * Tries to find a matching variant according to selected attributes, if it finds none or more than one, returns null
 * @param {Array<import('./selection.types.js').Variant>} variants
 * @param {import('./selection.types.js').AttributeValue} attributes
 * @param {import('./selection.types.js').AttributeValue} configurableAttributes
 * @returns {(import('./selection.types.js').Variant | null)}
 */
const findMatchingVariant = (variants = [], attributes = {}, configurableAttributes = {}) => {
    const matchingVariants = findMatchingVariants(variants, attributes, configurableAttributes);
    const numberOfMatches = matchingVariants.length;
    if (numberOfMatches === 0) {
        console.log('no matching variants found');
        return null;
    }
    else if (numberOfMatches === 1) {
        return matchingVariants[0];
    }
    else {
        console.log(`${numberOfMatches} matching variants found, returning null`);
        return null;
    }
};
exports.findMatchingVariant = findMatchingVariant;
const findMatchingVariants = (variants = [], attributes = {}, configurableAttributes = {}) => {
    return variants.filter((variant) => {
        return (0, isEqual_1.default)((0, pick_1.default)(variant, configurableAttributes), (0, pick_1.default)(attributes, configurableAttributes));
    });
};
exports.findMatchingVariants = findMatchingVariants;
/**
 * For a given product, find all variants that share the specified value
 * for the provided attributeCode (option code).
 * For example:
 *      Give me all variants of this product where `size` == `Queen`
 * @param {import('./selection.types.js').Product} productsData
 * @param {import('./selection.types').Attribute} attribute
 * @param {string} attributeValue
 * @returns
 */
const findVariantsWithAttributeValue = (productData, attribute, attributeValue) => {
    // Find all variants that match the provided attribute value
    const matchingAttributes = productData.configurableAttributes.filter(item => item === attribute);
    return findMatchingVariants(productData.variants, { [attribute]: attributeValue }, matchingAttributes);
};
exports.findVariantsWithAttributeValue = findVariantsWithAttributeValue;
/**
 * when figuring out the default variant selected when a user loads a screen there might be multiple sources of attributes
 * 1. the default variant if there have been no user saved attributes (defined in the catalog service)
 * 2. user saved attributes that are saved by configuring other products (defined by user cookies/settings)
 * 3. page specific attribute settings (defined by the page/controller)
 *
 * we want to return a single starting variant, which is probably some sort of merge of these
 * if we straight up merged these we might not find a matching variant so there should be some sort of merge of variants
 * @param {Array<import('./selection.types.js').Variant>} variants
 * @param {import('./selection.types.js').AttributeValue} configurableAttributes
 * @param {import('./selection.types.js').AttributeValue} defaultAttributes
 * @param {import('./selection.types.js').AttributeValue} pageDefinedAttributes
 * @param {import('./selection.types.js').AttributeValue} userDefinedAttributes
 * @returns {(import('./selection.types.js').Variant)}
 */
const findClosestVariant = (variants = [], configurableAttributes = {}, defaultAttributes = {}, pageDefinedAttributes = {}, userDefinedAttributes = {}) => {
    // TODO: implement algorithm to find closest match following some sort of priority
    const attributes = {
        ...defaultAttributes,
        ...pageDefinedAttributes,
        ...userDefinedAttributes
    };
    const matchingVariants = variants.filter((variant) => {
        return (0, isEqual_1.default)((0, pick_1.default)(variant, configurableAttributes), (0, pick_1.default)(attributes, configurableAttributes));
    });
    const numberOfMatches = matchingVariants.length;
    if (numberOfMatches === 0) {
        return variants[0];
    }
    else if (numberOfMatches > 0) {
        return matchingVariants[0];
    }
};
exports.findClosestVariant = findClosestVariant;
/**
 * currently we are just storing the whole variant + quantity as the state, we could do something to derive some state if we wanted
 * @param {import('./selection.types.js').Variant} variant
 * @param {number} quantity
 * @returns {import('./selection.types.js').Variant & { quantity: number }}
 */
const getStateFromVariant = (variant = {}, quantity = 0) => {
    return {
        ...variant,
        quantity
    };
};
exports.getStateFromVariant = getStateFromVariant;
/**
 *
 * @param {import('./selection.types.js').Product} productData
 * @param {import('./selection.types.js').AttributeValue} pageDefinedAttributes
 * @param {import('./selection.types.js').AttributeValue} userDefinedAttributes
 * @param {import('./selection.types.js').AttributeValue} productOverrides
 * @param {boolean} defaultInStock
 * @returns {Object.<string, import('./selection.types.js').Variant & { quantity: number }>}
 */
const getInitialState = (productData = {}, pageDefinedAttributes = {}, userDefinedAttributes = {}, productOverrides = {}, defaultInStock = false) => {
    const initialState = {};
    Object.entries(productData).forEach(([productCode, product]) => {
        const defaultAttributes = getDefaultAttributes(product);
        // If productOverrides exist, check if they are valid and update the initial selection.
        const overrides = productOverrides[productCode] && getProductOverrides(productOverrides[productCode], product);
        // If a valid sku query exists directly use the variant sku, otherwise find the closest variant based on configurable attributes.
        let initialVariant = overrides === null || overrides === void 0 ? void 0 : overrides.skuQueryOverride;
        if (!initialVariant) {
            initialVariant = findClosestVariant(product.variants, product.configurableAttributes, defaultAttributes, pageDefinedAttributes, userDefinedAttributes);
            // if defaultInStock is set and the closest variant is not in stock, pick the first in stock variant
            if (defaultInStock && initialVariant && !initialVariant.inStock) {
                initialVariant = product.variants.find(product => product.inStock) || initialVariant;
            }
        }
        if (!initialVariant) {
            console.log(`could not find initial variant for ${productCode}`);
            return;
        }
        // If a product does not have a configurable quantity, default to 1, so it can be added to cart
        const initialQuantity = (overrides === null || overrides === void 0 ? void 0 : overrides.qtyQueryOverride) || defaultAttributes.quantity || 1;
        const initialProductState = getStateFromVariant(initialVariant, initialQuantity);
        initialState[productCode] = initialProductState;
    });
    return initialState;
};
exports.getInitialState = getInitialState;
/**
 *
 * Applies overrides to the product state in the selection store, currently applies sku (variant) and quantity overrides
 * @param {Object} productOverrides
 * @param {import('./selection.types.js').Product} productData
 * @returns {{
 *  skuQueryOverride: string | null
 *  qtyQueryOverride: string | null
 * }}
 */
const getProductOverrides = (productOverrides = {}, productData) => {
    let skuQueryOverride = null;
    let qtyQueryOverride = null;
    // Determine if a valid sku query is present. Sku queries must be attached to a PDP url such as saatva.com/bedding/organic-cotton-sheets?sku=XXXXXXX
    if (productOverrides.skuQuery) {
        const validVariantSkuQuery = productOverrides.skuQuery && productData.variants.find((productVariant) => productVariant.sku === productOverrides.skuQuery);
        skuQueryOverride = validVariantSkuQuery || null;
    }
    // If a qty query param exists, user is on a PDP, and the QTY conforms to the available qty options for productCode, use the query param. Otherwise default to normal behavior.
    // qty queries are always attached to a PDP url.'?qty=3', '?sku=XXXX&qty=Y'
    // Product must have the option to add qty and the intended qty must be within the allowable range and greater than 0.
    if (productOverrides.qtyQuery) {
        const productQtyOption = (productOverrides.qtyQuery && Object.hasOwn(productData.options, 'quantity')) && productData.options.quantity;
        const isValidQtyOverride = productQtyOption && productOverrides.qtyQuery <= productQtyOption.values.length && productOverrides.qtyQuery > 0;
        qtyQueryOverride = isValidQtyOverride
            ? productOverrides.qtyQuery.toString()
            : null;
    }
    return {
        skuQueryOverride: skuQueryOverride,
        qtyQueryOverride: qtyQueryOverride
    };
};
exports.getProductOverrides = getProductOverrides;
const mergeProductAttributes = (currentState = {}, updatedAttributes = {}) => {
    return {
        ...currentState,
        ...updatedAttributes
    };
};
exports.mergeProductAttributes = mergeProductAttributes;
/**
 * Returns the products with their options sorted according to array order from catalog
 * @param {import('./selection.types.js').Product} productsData
 * @returns {Object.<string, import('./selection.types.js').Product>}
 */
const transformCatalogProducts = (productsData) => {
    const productObject = {};
    productsData.forEach(product => {
        const productOptions = {};
        product.options.forEach((option, i) => {
            productOptions[option.code] = {
                ...option,
                sortOrder: i
            };
        });
        productObject[product.productCode] = {
            ...product,
            options: productOptions
        };
    });
    return productObject;
};
exports.transformCatalogProducts = transformCatalogProducts;
/**
 * accept a list of variants and their data and return data required for adding the items to cart
 * @param {Array<ImportAttributes('./selection.types.js').Variant[]} variants
 * @returns {({
*  quantityOfProducts: number,
*  item: {
*      inStock: boolean,
*      sku: string,
*      type: string,
*      color: string,
*      size: string,
*      quantity: number,
*      bundleProductOptions: any[]
*      category: string,
*      parentSku: string,
*      price: number,
*      label: string
*  }
* })}
*/
const getVariantDataForCart = (variants = []) => {
    if (!variants)
        variants = [];
    let quantityOfProducts = 0;
    const items = variants.map((variant) => {
        const { sku, quantity, magentoBundleOptions, inStock, category, price, name, color, size, productCode } = variant;
        if (inStock) {
            const type = magentoBundleOptions ? 'bundle' : 'simple';
            // quantity is never 0, if inStock check is removed above, check inStock for quantity
            quantityOfProducts += parseInt(quantity);
            return {
                inStock,
                sku,
                type,
                color,
                size,
                quantity: parseInt(quantity),
                bundleProductOptions: [magentoBundleOptions],
                category: category && category.toLowerCase(),
                parentSku: productCode,
                price,
                label: name
            };
        }
    }).filter(item => item);
    return { quantityOfProducts, items };
};
exports.getVariantDataForCart = getVariantDataForCart;
/**
 * returns the folder and file for a filepath
 * this can be used for for generic images not associated with a specific product or variant
 * @param {String} descriptor
 * @param {String} ratio
 * @param {String} altTag
 * @returns {Object}
 * @property {String} folder
 * @property {String} file
 */
const _getAssetForFilepath = (descriptor, ratio, altTag, fileExt = 'jpg') => {
    let file;
    const lastSlashIndex = descriptor.lastIndexOf('/');
    const folder = descriptor;
    file = descriptor.substring(lastSlashIndex + 1);
    file = `${file}-${ratio}.${fileExt}`;
    return { folder, file, altTag };
};
/**
 * Creates altTag for assets bases on the genericName and the descriptor
 * @param {string} genericName
 * @param {string} descriptor
 * @returns {string}
 */
const _getAltTagString = (variantGenericName, descriptor) => {
    let altTag = '';
    if (descriptor === null || descriptor === void 0 ? void 0 : descriptor.includes('/')) {
        altTag = descriptor.split('/').join(' ');
    }
    else {
        altTag = `${variantGenericName} ${descriptor}`;
    }
    return altTag.replace(/-/g, ' ');
};
/**
 * returns assets for an specific descriptor for the selected variant
 * @param {Object} variant
 * @param {String} descriptor
 * @param {String} ratio
 * @returns
 */
const getAssetForVariant = (variant, descriptor, ratio) => {
    const altTag = _getAltTagString(variant.genericName, descriptor);
    // if the descriptor is a filepath, we need to extract the folder and file from the descriptor
    if (descriptor.includes('/')) {
        return _getAssetForFilepath(descriptor, ratio, altTag);
    }
    if (!Boolean(variant.assets)) {
        throw new Error(`getAssetForVariant: Assets element not found for ${variant.sku} variant. Check catalog service product query in the consuming app`);
    }
    else if (!Boolean(variant.assets.ardad)) {
        throw new Error(`getAssetForVariant: Ardad element not found for ${variant.sku} variant.assets. Check catalog service product query in the consuming app`);
    }
    const ardadForVariant = variant.assets.ardad.find(ardadItem => ardadItem.descriptor === descriptor);
    if (!Boolean(ardadForVariant)) {
        throw new Error(`getAssetForVariant: Ardad asset not found for sku ${variant.sku} with descriptor: ${descriptor}. Confirm the desired asset exists for the configured descriptor`);
    }
    else {
        const hasRequiredAttributes = ardadForVariant.folder && ardadForVariant.filenameBase && ardadForVariant.fileExt && ardadForVariant.descriptor;
        if (!hasRequiredAttributes) {
            throw new Error(`getAssetForVariant: Required Ardad asset attributes not found for sku ${variant.sku}. Requires folder, filenameBase, fileExt and descriptor. Check catalog service product query in the consuming app`);
        }
        return {
            folder: ardadForVariant.folder,
            file: `${ardadForVariant.filenameBase}-${ratio}.${ardadForVariant.fileExt}`,
            altTag: altTag
        };
    }
};
exports.getAssetForVariant = getAssetForVariant;
//# sourceMappingURL=selection.utils.js.map